module.exports = __webpack_public_path__ + "img/5_38.f05f7e5b.png";